import { createTheme, PaletteMode, PaletteOptions } from '@mui/material'

const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#78c2ad',
  },
  secondary: {
    main: '#f3969a',
  },
  error: {
    main: '#ff7851',
  },
  warning: {
    main: '#ffce67',
  },
  info: {
    main: '#6cc3d5',
  },
  success: {
    main: '#56cc9d',
  },
}
const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#78c2ad',
  },
  secondary: {
    main: '#444',
  },
  error: {
    main: '#e74c3c',
  },
  warning: {
    main: '#f39c12',
  },
  info: {
    main: '#3498db',
  },
  success: {
    main: '#00bc8c',
  },
}

function generateTheme(mode: PaletteMode) {
  return createTheme({
    palette: mode === 'dark' ? darkPalette : lightPalette,
    typography: {
      fontFamily: 'Roboto, "Noto Sans HK", Arial, Helvetica, sans-serif',
    },
  })
}
export const lightTheme = generateTheme('light')
export const darkTheme = generateTheme('dark')

export default lightTheme
